import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class WebRtcCallRequestOffer extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "webRtcCallRequestOffer";
    }

    onAction(payload: CometOperatorApplication.WebRtcCallRequestAnswerCometMessageOpenApiModel): void {
        let currentCall = AbstractWebRtcCall.getCurrentCall();
        if (currentCall?.getId() == payload.call.id) {
            currentCall.setCallData(payload.call);
            currentCall.sendOffer(payload.pairId);
        }
    }

}